import React from 'react';
import { Route, Switch, Redirect } from "react-router-dom";
import ProductList from 'components/artectum/grid/grid-product';
import ProductCategoryList from 'components/artectum/grid/grid-product-categories';
import ProductDetail from 'components/views/product-details';

const ProductRoutes = () => (
    <Switch>
        <Route exact path="/product/product-list" component={ProductList} />
        <Route exact path="/product/product-details/:id" component={ProductDetail} />
        <Route exact path="/product/product-list/:slug" component={ProductList} />
        <Route exact path="/product/product-categories/:id" component={ProductCategoryList} />
        <Route path="/product/*">
            <Redirect to="/product/product-list" />
        </Route>
    </Switch>
);

export default ProductRoutes;